import { useCallback, useState } from 'react';

export const useDisclosure = (defaultIsOpen = false) => {
  const [isOpen, setIsOpen] = useState(defaultIsOpen);

  const onOpen = useCallback(() => {
    setIsOpen(true);
  }, []);

  const onClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  const onOpenChange = useCallback(() => {
    setIsOpen((s) => !s);
  }, []);

  return {
    isOpen,
    onOpen,
    onClose,
    onOpenChange,
  };
};
